module.exports = __webpack_public_path__ + "static/doctolib-thumbnail-2-f06ca99cc1d3541925f82026f5e78431.png";